'use client'

import { Link } from '@/navigation'
import { Autoplay, FreeMode } from 'swiper'
import { useTranslations } from 'next-intl'
import { Swiper, SwiperSlide } from 'swiper/react'

import ProjectsCard from './components/ProjectsCard'

import type { FC } from 'react'
import type { IFetchedDataRoot, IProjectsData } from '@/types'

const Projects: FC<IFetchedDataRoot<IProjectsData>> = ({ results }) => {
  const t = useTranslations()

  return (
    <div className="container mx-auto px-4 py-[30px] md:py-12">
      <h2 className="mb-5 md:mb-[45px]">
        {t('ProjectsSection.title')}
      </h2>

      <Swiper
        modules={[Autoplay, FreeMode]}
        loop
        freeMode
        grabCursor
        autoplay={{
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        speed={5000}
        slidesPerView="auto"
        spaceBetween={24}
        className="mb-5 md:mb-10"
      >
        {results.map((data, i) => (
          <SwiperSlide
            key={data.slug + i}
            className="!w-[320px] md:!w-[480px]"
          >
            <ProjectsCard {...data} />
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="flex justify-center">
        <Link
          href="/projects"
          className="btn-primary"
          aria-label={t('Buttons.AllProjects')}
        >
          {t('Buttons.AllProjects')}
        </Link>
      </div>
    </div>
  )
}

export default Projects
